import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Home, ArrowLeft } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
    
    // Add noindex meta tag for 404 page
    const metaRobots = document.querySelector('meta[name="robots"]');
    const originalContent = metaRobots?.getAttribute("content") || "";
    if (metaRobots) {
      metaRobots.setAttribute("content", "noindex, nofollow");
    }
    
    // Update document title
    document.title = "Stránka nenalezena | ESKO Servis";
    
    return () => {
      // Restore original robots meta on unmount
      if (metaRobots && originalContent) {
        metaRobots.setAttribute("content", originalContent);
      }
      document.title = "ESKO Servis | Elektroinstalace a elektromontáže Teplice";
    };
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navbar />
      
      <main className="flex-1 flex items-center justify-center py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-lg mx-auto text-center">
            {/* 404 Visual */}
            <div className="mb-8">
              <span className="text-8xl md:text-9xl font-black text-primary/20">404</span>
            </div>
            
            {/* Content */}
            <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
              Stránka nenalezena
            </h1>
            <p className="text-lg text-muted-foreground mb-8">
              Omlouváme se, ale požadovaná stránka neexistuje nebo byla přesunuta.
            </p>
            
            {/* Actions */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/">
                <Button size="lg" className="w-full sm:w-auto">
                  <Home className="mr-2 h-5 w-5" />
                  Zpět na úvodní stránku
                </Button>
              </Link>
              <Button 
                size="lg" 
                variant="outline" 
                onClick={() => window.history.back()}
                className="w-full sm:w-auto"
              >
                <ArrowLeft className="mr-2 h-5 w-5" />
                Předchozí stránka
              </Button>
            </div>
            
            {/* Help text */}
            <p className="mt-8 text-sm text-muted-foreground">
              Potřebujete pomoc? Zavolejte nám na{" "}
              <a 
                href="tel:+420732658712" 
                className="text-primary hover:underline font-medium"
              >
                +420 732 658 712
              </a>
            </p>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default NotFound;
